// extracted by mini-css-extract-plugin
export default {"Header":"layout_Header__4Bczz","AccountIcon":"layout_AccountIcon__l2VAd","AccountIconContainer":"layout_AccountIconContainer__8GORP"};